import type { ReactNode } from 'react';

/**
 * 검색어와 일치하는 부분만 <span className="match">로 감싼다.
 * match 색상(#0066CC 등)은 사용하는 쪽 스타일에서 지정.
 */
const highlightKeyword = (text: string, query: string): ReactNode => {
  const trimmed = query.trim();
  if (!trimmed) return text;
  const idx = text.toLowerCase().indexOf(trimmed.toLowerCase());
  if (idx < 0) return text;
  return (
    <>
      {text.slice(0, idx)}
      <span className="match">{text.slice(idx, idx + trimmed.length)}</span>
      {text.slice(idx + trimmed.length)}
    </>
  );
};

export default highlightKeyword;
